import { isJSXElement } from "@utils/common";
import React from "react";

interface FeatureCardSectionProps {
    isImageRightSide?: boolean;
    subTitle?: string;
    title: string;
    description: string | JSX.Element;
    imageURl: string;
}
/**
 * @deprecated The component should not be used. Instead use FeatureCardV2
 */
const FeatureCardSection: React.FC<FeatureCardSectionProps> = (props) => {
    const { isImageRightSide = false, description, title, subTitle, imageURl } = props;
    return (
        <section className="feature-card_section max-w-6xl flex space-x-5 mx-auto lg:mt-10 mt-20  ">
            {isImageRightSide ? (
                <div className="flex lg:flex-row flex-col lg:gap-8 w-full h-full">
                    <div className="lg:w-1/2 flex lg:justify-center lg:items-center w-full lg:px-0 px-3">
                        <div className="flex flex-col space-y-8">
                            <div>
                                <p className="lg:text-xl text-base lg:text-left text-center  lg:block text-blue-500 font-medium">{subTitle}</p>
                                <h2 className="text-gray-700 lg:text-left text-center lg:text-4xl text-2xl lg:font-bold font-semibold">{title}</h2>
                            </div>
                            <div>
                                {isJSXElement(description) ? (
                                    description
                                ) : (
                                    <p className="lg:text-base text-base lg:text-left text-center text-gray-600 lg:font-normal">{description}</p>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="lg:w-1/2 h-full w-full">
                        <img width="600px" height="500px" src={imageURl} alt={title} />
                    </div>
                </div>
            ) : (
                <div className="flex lg:flex-row flex-col lg:gap-8 w-full h-full">
                    <div className="lg:w-1/2 order-2 lg:order-1 ">
                        <img width="600px" height="500px" src={imageURl} alt={title} />
                    </div>
                    <div className="lg:w-1/2 flex order-1 lg:justify-center lg:items-center w-full lg:px-0 px-3">
                        <div className="flex flex-col space-y-8">
                            <div>
                                <p className="lg:text-xl lg:text-left text-base text-center lg:block text-blue-500 font-medium">{subTitle}</p>
                                <h2 className="text-gray-700 lg:text-left text-center lg:text-4xl text-2xl lg:font-bold font-semibold">{title}</h2>
                            </div>
                            <div>
                                <p className="lg:text-base lg:text-left text-center text-gray-600 lg:font-normal">{description}</p>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </section>
    );
};

export default FeatureCardSection;
